/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1    Mahesh       17/01/2020      1971: Symptom Selector Implementation.
CHID-2     Usha        19/02/2020      2691: Symptom Selector revised screen
*********************************************************************************/

import { Component } from "@mna/react";
import Modal from "@mna/react-ui/Modal";
import IconX from "assets/icons/x.svg";
import SymptomSearchResults from "./SymptomSearchResults";
import { classnames as cx } from "@mna/react";
import { Trans } from "react-i18next";
import i18next from "i18next";
import {checkAndGetLocalStorageValue } from "../../../features/utils"

export default class SymptomSearch extends Component {
  state = {
    showModal: true,
    symptomSearchText: "",
    symptomSearchCalled: false,
    symptomsAdded: [],
  };
  componentDidMount() {
    Modal.setAppElement("#root");
  }
  openModal = () =>
    this.setState({
      showModal: true,
      symptomsAdded: [],
    });
  closeModal = () =>
    this.setState({
      showModal: true,
      symptomSearchText: "",
      symptomSearchCalled: false,
      symptomsAdded: [],
    });
  searchTerm({ text }) {
    if (!text) return;
    let allSymptomsobject = null;
    const { actions } = this.props;
    //CHID-2 1971
    allSymptomsobject = JSON.parse(localStorage.getItem("symptoms"));
    const allSymptoms = allSymptomsobject.symptoms;
    actions.searchSymptoms({ text, allSymptoms }).then(() =>
      this.setState({
        symptomSearchText: text,
        symptomSearchCalled: text,
      })
    );
  }

  handleInputFocus = () => {
    setTimeout(() => window.scrollTo(0, 0), 3000);
  };

  render() {
    const {
      setState,
      state,
      state: { symptomSearchResult, currentSymptomTitles },
      actions,
      history,
    } = this.props;
    //CHID-2 1971 start
    var filterSymptoms = JSON.parse(localStorage.getItem("symptoms"));
    var commanSymptoms = filterSymptoms.symptoms.filter((result) => result);
    commanSymptoms.sort((a, b) => {
      let x = a.common_name;
      let y = b.common_name;
      return x < y ? -1 : x > y ? 1 : 0;
    });
    return (
      <div>
        <div>
          <h1
            className="text-left standby-page-header-title symptom-header-title mt-0 mb-3"
          >
            <Trans i18nKey="findcareoption.NLPSymptom.What_Wrong">
              What's Wrong?{" "}
            </Trans>{" "}
          </h1>
            <h2 className="fontWeight text-left">
              <Trans i18nKey="findcareoption.NLPSymptom.symptomsubheading">
               Please describe your symptoms:
              </Trans>{" "}
            </h2>
        </div>
        <div className="symptom-box">
          <div className=" standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center ">
            <div className="symptom-textbox">
              <input
                type="text"
                className="standby-symptom-search-field"
                name="symptomSearchText"
                autoComplete="off"
                value={this.state.symptomSearchText}
                onFocus={this.handleInputFocus}
                onChange={(e) => {
                  window.scrollTo(0, 0);
                  if (e.target.value.length > 1) {
                    this.setState({
                      symptomsAdded: [],
                      symptomSearchText: e.target.value,
                    });
                    this.searchTerm({ text: e.target.value });
                  } else {
                    this.setState({
                      symptomsAdded: [],
                      symptomSearchText: e.target.value,
                    });
                  }
                }}
                placeholder={i18next.t(
                  "findcareoption.SymptomSelector.search_placeholder"
                )}
                autoFocus={!this.state.symptomSearchText}
              />
            </div>
            {}
          </div>
        </div>

       
        <div className="contentset">
          {!this.state
            .symptomSearchText ? null : !symptomSearchResult.length ? (
            <div className="text-bold">
              <Trans i18nKey="findcareoption.SymptomSelector.nosymptom">
                No symptoms were found that matches the text.
              </Trans>
            </div>
          ) : (
            <SymptomSearchResults
              {...{
                results: symptomSearchResult,
                symptomsAdded: this.state.symptomsAdded,
                currentSymptomTitles,
                actions,
                setModalState: this.setState.bind(this),
                symptomSearchText: this.state.symptomSearchText,
              }}
            />
          )}
        </div>

    {state.currentSymptomsSortedKeys.length ?
        <div className="pt-2">
        <h2 className="symptom-content text-left" tabIndex="0">
          <Trans i18nKey="findcareoption.NLPSymptom.Sel_Symptoms">
            Selected Symptoms:
          </Trans>
        </h2>
        <ul className="SelectedSymptoms standby-symptom-list">
          {state.currentSymptomsSortedKeys.map((key) => (
            <li
              key={`symptom-added-${state.currentSymptomsMap[key].id}`}
              className="standby-symptom-list-item"
            >
              <button
                type="button"
                className="button standby-symptom-button standby-symptom-button-remove"
                onClick={() => {
                  var selectedSymptom = state.currentSymptomsMap[key];
                  actions.removeSymptom({
                    symptom: selectedSymptom,
                  });
                  this.setState({
                    symptomsAdded: this.state.symptomsAdded.filter(
                      (common_name) =>
                        common_name !== selectedSymptom.common_name
                    ),
                  });
                }}
              >
                <div
                  className="icon userSelected-symptoms"
                  id = {`${state.currentSymptomsMap[key].common_name}`}
                >
                  <IconX id={`iconX_${state.currentSymptomsMap[key].common_name}`}/>
                </div>
                <div className="standby-symptom-button-text">
                  {`   ${state.currentSymptomsMap[key].common_name}`}
                </div>
              </button>
            </li>
          ))}
        </ul>
        <div className="standby-btn-done contentset pb-3">
          <input
            type="submit"
            className={cx(
              "button standby-symptom-search-submit",
              state.currentSymptomsSortedKeys.length
                ? "standby-button-square-green"
                : "standby-button-disabled"
            )}
            value={i18next.t("findcareoption.NLPSymptom.Done")}
            onClick={() => {
              if (state.currentSymptomsSortedKeys.length > 0) {
                state.triageRequest.Symptoms =
                  state.currentSymptomsSortedKeys;
                const primarySymptom =
                  (state.currentSymptomsSortedKeys[0] &&
                    state.currentSymptomsMap[
                      state.currentSymptomsSortedKeys[0]
                    ] &&
                    state.currentSymptomsMap[
                      state.currentSymptomsSortedKeys[0]
                    ].id) ||
                  0;
                actions.setPrimarySymptom({
                  primarySymptom,
                });
                setState({ isLoading_PrioritySymptom: false });
                history.push(`/find-care-options/${"symptom-priority"}`);
              }             
              gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
            }}
          />
        </div>
      </div> : "" }
      </div>
    );
  }
}
